import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { TextButtonInternalSharedComponent } from './text-button-internal.component';
import { IconSharedModule } from '../../atoms/icon/icon.module';

@NgModule({
    declarations: [
        TextButtonInternalSharedComponent
    ],
    imports: [
        CommonModule,
        IconSharedModule,
        RouterModule.forChild([])
    ],
    exports: [
        TextButtonInternalSharedComponent
    ]
})

export class TextButtonInternalSharedModule {}
